import React from "react";
import { oneOf, shape, string } from "prop-types";

//Components
import Icon from "../../components/Icon";

//Style
import UIkit from "uikit";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "@magento/venia-ui/lib/components/Header/header.css";
import myClasses from "./headerbasic.module.scss";
import { useHistory, useLocation } from "react-router-dom";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
var HeaderBasic = props => {
  var {
    color,
    path,
    title,
    backFunction,
    hideBack,
    extraStyle,
    header = false,
    isCircled = true,
    isFixed = false,
    backgroundClassColor
  } = props;
  var history = useHistory();
  var location = useLocation();
  var classes = mergeClasses(defaultClasses, myClasses, props.classes);
  var titleColor = classes[color];
  var goBack = () => {
    try {
      var _location$state;
      if (path === "close") {
        UIkit.offcanvas("#offcanvas-login-dx").hide();
      } else if (path === "goBack") {
        history.goBack();
      } else if (path === "closeSignUp") {
        UIkit.offcanvas("#offcanvas-registration-dx").hide();
      } else if (path.startsWith("#")) {
        UIkit.offcanvas(path).show();
      } else if ((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.from) {
        history.push(path, {
          from: location.state.from
        });
      } else {
        history.push(path);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return /*#__PURE__*/React.createElement("header", {
    className: " ".concat(classes.root, " ").concat(extraStyle ? classes[extraStyle] : "", " ").concat(isFixed ? 'uk-position-fixed' : '', " ").concat(backgroundClassColor ? backgroundClassColor : '', " header-basic")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.primaryActions,
    style: {
      visibility: backFunction ? "visible" : "hidden"
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.buttonBack,
    onClick: backFunction ? backFunction : !hideBack ? goBack : () => {},
    style: hideBack ? {
      opacity: "0"
    } : {}
  }, /*#__PURE__*/React.createElement(Icon, {
    header: header,
    name: "icon-arrow-left",
    color: color,
    isCircled: isCircled
  }))), /*#__PURE__*/React.createElement("span", {
    className: titleColor
  }, title)));
};
HeaderBasic.propTypes = {
  classes: shape({
    closed: string,
    logo: string,
    open: string,
    toolbar: string,
    buttonBack: string
  }),
  color: oneOf(["black", "white"]).isRequired,
  path: string,
  title: string.isRequired
};
HeaderBasic.defaultProps = {
  color: "black",
  path: "/pre-login",
  offcanvasLink: true
};
export default HeaderBasic;